import { isIframe } from 'iframe-support'

export function getMainWindow() {
  let mainWindow = window
  if (isIframe()) {
    mainWindow = window.parent
    try {
      // This may be blocked by browser's same origin policy
      if (typeof window.top.location.search !== 'undefined') {
        mainWindow = window.top
      }
    } catch (e) {
      // Handle any exceptions that may occur inside the try block
      console.error(e)
    }
  }
  return mainWindow
}
